import React, { Component, Fragment } from 'react';
import Head from 'next/head';
import styled from 'styled-components';
import { node, string, oneOfType, arrayOf, bool, func } from 'prop-types';
import Swipeable from 'react-swipeable';

import Footer from '../Footer';
import Header from '../Header';
import ErrorBoundary from '../shared/ErrorBoundary';

import { GREY_COLOR, WHITE_COLOR } from '../../constants';

const ContentWrapper = styled.div`
  height: calc(100%);
  bottom: 0;
  display: flex;
  flex-direction: column;
`;

const ContentChildrenWrapper = styled.div`
  flex: 1 0 auto;
`;

const transparentState = {
  backgroundColor: 'transparent',
  fontColor: WHITE_COLOR,
};

const opaqueState = {
  backgroundColor: WHITE_COLOR,
  fontColor: GREY_COLOR,
};

class Layout extends Component {
  state = {
    headerColor: this.props.hasTransparentHeader
      ? transparentState
      : opaqueState,
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);

    const { hasTransparentHeader } = this.props;

    if (hasTransparentHeader) {
      this.setState({ headerColor: transparentState });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const { hasTransparentHeader } = this.props;

    if (window.scrollY === 0 && hasTransparentHeader) {
      this.setState({ headerColor: transparentState });
    } else {
      this.setState({ headerColor: opaqueState });
    }
  };

  render() {
    const {
      children,
      title = 'Dame hru?',
      hasTransparentHeader,
      updateQuery,
      updateSearch,
      showSearchBar,
      updateI18lCategoryList,
      resetState,
    } = this.props;

    return (
      <Swipeable onSwipedRight={() => window.history.back()}>
        <Fragment>
          <Head>
            <title>{title}</title>
          </Head>

          <ErrorBoundary>
            <Header
              resetState={resetState}
              headerColor={this.state.headerColor}
              isTransparent={hasTransparentHeader}
              updateQuery={updateQuery}
              updateSearch={updateSearch}
              showSearchBar={showSearchBar}
              updateI18lCategoryList={updateI18lCategoryList}
            />
          </ErrorBoundary>
          <ContentWrapper>
            <ErrorBoundary>
              <ContentChildrenWrapper>
                <main>{children}</main>
              </ContentChildrenWrapper>
            </ErrorBoundary>

            <Footer />
          </ContentWrapper>
        </Fragment>
      </Swipeable>
    );
  }
}

Layout.propTypes = {
  updateQuery: func,
  updateSearch: func,
  showSearchBar: bool.isRequired,
  children: oneOfType([arrayOf(node), node]).isRequired,
  title: string,
  hasTransparentHeader: bool,
  updateI18lCategoryList: func,
  resetState: func,
};

export default Layout;



// WEBPACK FOOTER //
// components/Layout/index.js